export const MODULE_NAME = 'FINANCE_APPLICATION_REPORT_MODULE';
